import {Component} from 'react';
import h from 'react-hyperscript';
import {googleCalendarUrl} from 'Src/utils/utils';
import './AddToCalendar.scss';

class AddToCalendar extends Component {
  constructor(props) {
    super(props);
    this.calUrl = null;
  }

  componentWillMount() {
    const {title, desc, date} = this.props;

    this.calUrl = googleCalendarUrl({title, desc, date});
  }

  render() {
    return (
      h('div', {className: 'add-to-calendar-pdw'}, [
        h('a', {
          key: `cta`,
          className: 'button--cal text--blue',
          type: 'flat',
          target: '_blank',
          href: this.calUrl,
        }, [
          h('span', {
            className: 'material-icons padding-right--micro',
          }, 'calendar_today'),
          'Add to Calendar',
        ]),
      ])
    );
  }
}

export default AddToCalendar;
